import  axios from  "axios";

// // 创建实例时设置配置的默认值
// var instance = axios.create({
//     baseURL: 'http://localhost:1234',
//     timeout:5000
// });

const loginStatus = '用户信息不存在'
let statusOk = '200'
//请求头拦截
// axios.interceptors.request.use(config => {
//     // 在发送请求之前做些什么
//     let pathname = location.pathname;
//     if (localStorage.getItem('token')) {
//         if (pathname != '/' && pathname != '/login') {
//             //非首页和登录接口以外的接口 都需要设置token验证
//           //  config.headers.common['token'] = localStorage.getItem('token');
//         config.headers.common["token"]="admin";
//         }
//      config.headers['Content-Type']="application/json";
//      config.data=JSON.stringify(config.data); 
//     }
//     // NProgress.start();
//     return config;
// }, error => {
//     // 对请求错误做些什么
//     return Promise.reject(error);
// });
//响应头拦截
// axios.interceptors.response.use(response => {
//     
  
//      return response

// },error => {
// if (error.response) {
//     switch (error.response.status) {
//         // 返回401，清除token信息并跳转到登录页面
//         case 404:
//             alert("跳到错误页面");
//         break;
//     }
//     // 返回接口返回的错误信息
//     return Promise.reject(error.response.data);
// }
// });

export  default  axios;